import Spinner from "../../shared/UxbiSpinner";
import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function WdowConfirm({
  show,
  onHide,
  onConfirm,
  title = "Confirmar",
  message,
  type = "confirm",
  data = [],
  loading = false,
}) {
  return (
    <Modal
      show={show}
      onHide={loading ? null : onHide}
      backdrop="static"
      keyboard={false}
      centered
      className="modal-backdrop-dark"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {data?.length > 0 && (
          <>
            <p>
              Se encontraron similitudes con los siguientes clientes/prospectos:
            </p>

            <ul style={{ maxHeight: 200, overflowY: "auto" }}>
              {data.map((item, i) => (
                <li key={i}>{item.nombre || item.razon_social}</li>
              ))}
            </ul>
          </>
        )}
        {message && <p className="mt-2">{message}</p>}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancelar
        </Button>

        <Button
          variant={type === "warning" ? "warning" : "success"}
          onClick={onConfirm}
        >
          {loading ? (
            <>
              <Spinner size="sm" />
              Procesando...
            </>
          ) : (
            "Continuar"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
